import { gql } from '@apollo/client';
export const REFRESH_TOKEN = gql`
  mutation refreshToken($input: RefreshTokenInput!) {
    refreshToken(input: $input) {
      tokenType
      accessToken
      refreshToken
      expiresIn
    }
  }
`;
export const REFRESH_TOKEN_DEFAULT_OPTIONS = (refreshToken, email) => {
  return {
    variables: {
      input: {
        refreshToken,
        email
      }
    }
  };
};
export const LOGOUT = gql`
  mutation logout {
    logout
  }
`;